import React from 'react'
import { Checkbox } from 'components/common/Checkbox/Checkbox'
import { Collapse } from 'components/common/Collapse'
import { FlexColumn } from 'components/common/Containers'
import styles from '../index.module.scss'

const nameFilters = [
  {
    label: 'No hyphens (-)',
    value: 'no_hyphens',
  },
  {
    label: 'No numerals (0-9)',
    value: 'no_numerals',
  },
  {
    label: 'No special char',
    value: 'no_unicode',
  },
]

interface Values {
  no_hyphens: 'True' | 'False'
  no_unicode: 'True' | 'False'
  no_numerals: 'True' | 'False'
}

interface Props {
  values: Values
  onChange: (values: Values) => void
}

const NameFilter: React.FC<Props> = ({ values, onChange }) => {
  return (
    <Collapse
      header={<h6 className={styles.filterTitle}>Name</h6>}
      gap="20px"
      hasArrow
      defaultOpen
    >
      <FlexColumn gap="9px" align="normal">
        {nameFilters.map((filter) => (
          <Checkbox
            key={filter.value}
            value={filter.value}
            checked={values[filter.value] === 'True'}
            isFormik={false}
            onChange={(event) => {
              onChange({
                ...values,
                [filter.value]: event.target.checked ? 'True' : 'False',
              })
            }}
          >
            {filter.label}
          </Checkbox>
        ))}
      </FlexColumn>
    </Collapse>
  )
}

export default NameFilter
